<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="500" scrollable persistent>
      <v-card class="rounded-lg">
        <v-card-text style="text-align: center; padding-top: 30px">
          <img
            height="100"
            width="100"
            :src="require('@/assets/img/waste.gif')"
          />
          <br />
          <h2 class="pt-3">{{ $t("SettingBot.deletebot") }}</h2>
          <br />
          <p style="font-size: 15px">
            {{ $t("SettingBot.botname") }} <b> {{ _item.BotId }}</b>
            {{ $t("smtp.text10") }}
          </p>
        </v-card-text>
        <v-card-actions style="justify-content: center" class="pb-5">
          <v-btn color="#077893" dark dense @click="fn_save()">
            {{ $t("smtp.text12") }}
          </v-btn>
          <v-btn color="red" text @click="close()">
            {{ $t("smtp.text11") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import authorization from "@/functions/authorization.js";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_item"],
  data: function () {
    return {};
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogDelete");
        }
      },
    },
  },
  methods: {
    async fn_save() {
        var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var auth = await authorization.encodeDataNew(Headers);
      var headers = {
        "Authorization": "Bearer " + auth,
        "Access-Control-Allow-Origin": "*",
        "ngrok-skip-browser-warning": "true",
        "Content-Type": "application/json",
      };
      this.axios
        .delete(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            `onechat/Bot/${this._item.Id}`,
          {
            headers,
          }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.$emit("closeDialogDelete");
            this.$emit("reData");
            Toast.fire({
              icon: "success",
              title: response.data.Message,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
        });
    },
    close() {
      this.$emit("closeDialogDelete");
    },
  },
};
</script>

<style></style>
